import {Card, CardBody, CardHeader, CardImg, Col, Row} from "reactstrap";
import {useSelector} from "react-redux";

import {contactMethodsTypes} from "@utils/types/contactMethodsTypes";
import Form from "./components/form";
import ContactDetails from "./components/contactDetails";
import SocialMedia from "./components/socialMedia";
import ContactUsSkeleton from "./components/skeleton";

import "./style.scss";
import {FormattedMessage} from "react-intl";
import SectionTitle from "@webViews/components/titles/sectionTitle";

import LowCost from "@assets/images/elements/Low-cost.webp"
import LowRisk from "@assets/images/elements/low-risk.webp"
import Support from "@assets/images/elements/support.webp"

const headerInformation = [
    {
        image:LowCost,
        title:"سرمایه کـم",
        content:"امروزه ایجاد یک کسب و کار موفق با سرمایه پایین تبدیل به یک دغدغه برای کارفرمایان گردیده است، با توجه به این شرایط شما می تونید با داشتن سرمایه کمتری جهت شروع یک کسب و کار موفق اقدام نموده و به موفقیت چشم گیری برسید."
    },
    {
        image:LowRisk,
        title:"ریسک پایین",
        content:"ما با داشتن سال ها تجربه موفق در بازار و همچنین واگذاری شعب در شهرهای مختلف کاملا به سازوکار و روند فرانچایز آشنایی داشته و توانسته با تکیه بر شعار اصلی خود یعنی معجزه بافت حضور موفقی در بازار داشته باشد."
    },
    {
        image:Support,
        title:"پشتیبانی حرفه ای",
        content:"در همه مراحل فرانچایز از دکوراسیون و آمادگی فروشگاه شما و افتتاحیه شعبه تا تمامی مراحل، ما با شما در جهت ایجاد یک همکاری موثر و دوستانه با اندیشه ایجاد حس خوب برای همه کاربران خود درکنار شما خواهد بود."
    }
]

const ReservationRequest = () => {
    const addresses = useSelector(state => state.UI.general?.addresses);
    const contactMethods = useSelector(state => state.UI.general?.social_media);

    const phones = contactMethods?.filter(contactMethod => [contactMethodsTypes.phone, contactMethodsTypes.mobile].includes(parseInt(contactMethod.type)));

    const socialMedia = contactMethods?.filter(contactMethod => !phones.includes(contactMethod));

    return (
        <div className="reservation-request container-costumer my-5 px-1 px-md-5">
                <SectionTitle type="1" title={<FormattedMessage id="agency"/>}/>
            {(!phones || !socialMedia) ?
                <ContactUsSkeleton/>
                :
                <Row className="reservation-request-content mt-2">

                    <Col xs={12}>
                        <Row className="reservation-request-content-header">
                            {
                                headerInformation?.map((item , index) =>{
                                    return<Col xs={12} sm={6} md={4} >
                                        <Card className="reservation-request-content-header-box">
                                            <CardHeader className={"justify-content-center"}>
                                                <img src={item.image} />
                                            </CardHeader>
                                            <CardBody>
                                                <h3 className={"text-center"}>
                                                    {item.title}
                                                </h3>
                                                <p>{item.content}</p>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                })
                            }
                        </Row>
                    </Col>

                    <Col xs={12} md={8}
                         className='reservation-request-content-right rounded-lg p-1 p-md-3 d-flex align-items-center justify-content-center'>
                        <Form/>
                    </Col>
                    <Col xs={12} md={4} className='reservation-request-content-left rounded-lg p-3'>
                        <ContactDetails
                            addresses={addresses}
                            phones={phones}
                        />
                        <SocialMedia data={socialMedia}/>
                    </Col>

                </Row>
            }
        </div>
    );
};

export default ReservationRequest;
